import { Directive, Input, forwardRef, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidatorFn, AbstractControl, Validators } from '@angular/forms';

// "disable" annotation added to prevent following lint error:
//  ERROR: min.directive.ts[9, 33]: variable 'MinValidatorDirective' used before declaration
// tslint:disable:no-use-before-declare
const MIN_VALIDATOR: any = {
  provide: NG_VALIDATORS,
  useExisting: forwardRef(() => MinValidatorDirective),
  multi: true,
};
// tslint:enable:no-use-before-declare

@Directive({
  selector: '[appMin]',
  providers: [MIN_VALIDATOR],
})
export class MinValidatorDirective implements Validator, OnChanges {
  @Input() appMin: number;

  private validator: ValidatorFn;
  private onChange: () => void;

  ngOnChanges(changes: SimpleChanges) {
    for (const key in changes) {
      if (key === 'appMin') {
        if (this.onChange) {
          this.onChange();
        }
      }
    }
  }

  validate(c: AbstractControl): { [key: string]: any } {
    if (this.appMin === undefined || this.appMin === null) {
      return null;
    }
    if (!(Validators.required(c) === undefined || Validators.required(c) === null)) {
      return null;
    }

    const v: number = +c.value;
    return v >= +this.appMin ? null : { actualValue: v, requiredValue: +this.appMin, min: true };
  }

  registerOnValidatorChange(fn: () => void): void {
    this.onChange = fn;
  }
}
